module.exports = __webpack_public_path__ + "static/media/cross-black.0be45eba.svg";